const ReportsNames = {
  Historical: {
    ACIS: "ACIS Bond Historical",
    CIRT: "CIRT Deal Historical",
    DEAL: "Deal Historical",
    BOND: "Bond Historical"
  }
};
export default ReportsNames;
